import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PatchedRegistrationWriteRequest } from '~/apis/ssf';
import { keys } from './queries';
import { keys as competitionKeys } from '~/pages/competition/queries';
import { SSF } from '~/apis/api';

export function useCreateCompetitionRegistrationMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.registrationsCreate,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: keys.all });
      client.invalidateQueries({ queryKey: competitionKeys.all });
    },
  });
}

export function useDeleteCompetitionRegistrationMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.registrationsDestroy,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: keys.all });
      client.invalidateQueries({ queryKey: competitionKeys.all });
    },
  });
}

export function usePartialUpdateCompetitionRegistrationMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: PatchedRegistrationWriteRequest }) =>
      SSF.api.registrationsPartialUpdate(id, payload),
    onSuccess: ({ data: response }) => {
      client.invalidateQueries({ queryKey: keys.detail(response.id) });
      client.invalidateQueries({ queryKey: keys.lists() });
    },
  });
}
